import { Link } from "react-router-dom";
import React from "react";

function Footer() {
  const currentYear = new Date().getFullYear();

  const sriLankaContact = {
    mobile: "+94 769165200",
    email: "lankalasalle@gmail.com",
    address:
      "De La Salle Provincialate Secretariat, No. 130, De La Salle Street, Mutwal, Colombo 01500, Sri Lanka.",
  };

  const indiaContact = {
    mobile: "+91 8220996473",
    email: "india.delasallebrs@gmail.com",
    address:
      "Boys' Town, Pulluthu Post, Nagamalai Via, Madurai, TamilNadu - 625019",
  };

  return (
    <>
      <footer className="site-footer">
        <div className="footer-widgets">
          <div className="container">
            <div className="row">
              {/* About Us */}
              <div className="col-12 col-md-6 col-lg-3">
                <div className="section-heading">
                  <h2 className="entry-title">About Us</h2>
                </div>
                <div className="row" style={{ marginTop: "-19px" }}>
                  <div className="col-4 pt-3">
                    <img
                      src="/images/all-img/delasalle.png"
                      alt=""
                      style={{
                        display: "block",
                        marginLeft: "-50px",
                      }}
                    />
                  </div>
                  <div className="col-8 pt-3">
                    <p
                      style={{
                        color: "white",
                        textAlign: "justify ",
                        fontSize: "13px",
                      }}>
                      Founder of the Institute of the brothers of the Christian
                      Schools (De Lasalle Brothers), Patron of Christian
                      teachers, Educational Reformer and Father of Modern
                      Pedagogy.
                    </p>
                  </div>
                  <p
                    style={{
                      color: "white",
                      textAlign: "justify",
                      fontSize: "13px",
                    }}>
                    The Brothers of the Christian Schools, also known as De La
                    Salle Brothers, is a religious congregation of men founded
                    by Saint John Baptist De La Salle, patron saint of teachers
                    of youth.
                  </p>
                </div>
              </div>

              {/* Lasallian World */}
              <div className="col-12 col-md-6 col-lg-3">
                <div className="foot-latest-news">
                  <div className="section-heading">
                    <h2 className="entry-title">Lasallian World</h2>
                  </div>
                  <a
                    href="https://www.google.com/maps/d/u/0/viewer?ll=-3.81666561775622e-14%2C123.14054315101906&z=1&mid=1kiTIBWP9BQikhL7NlrCTwnVN5Ax9gz-O"
                    target="_blank"
                    rel="noopener noreferrer">
                    <img
                      src="/images/all-img/footimage.jpg"
                      alt="nodata"
                      className="img-fluid"
                      style={{ marginTop: "-20px", paddingTop: "20px" }}
                    />
                  </a>
                </div>
              </div>

              {/* ✅ Corrected Contact Us Section */}
              <div className="col-12 col-md-6 col-lg-3 pb-6">
                <div className="foot-contact">
                  {/* Fixed Heading Position */}
                  <div
                    className="section-heading"
                    style={{
                      marginBottom: "20px",
                      textAlign: "left",
                      // borderBottom: "2px solid #ffd700",
                      // paddingBottom: "8px",
                    }}
                  >
                    <h2
                      className="entry-title"
                      style={{
                        margin: 0,
                        color: "#fff",
                        fontSize: "20px",
                      }}
                    >
                      Contact Us
                    </h2>
                  </div>


                  {/* India Contact */}
                  <div className="contact-section pt-3">
                    <div
                      style={{
                        backgroundColor: "#1a365d",
                        padding: "8px 12px",
                        marginBottom: "10px",
                        borderLeft: "4px solid #ffd700",
                      }}
                    >
                      <h5
                        style={{
                          color: "#ffd700",
                          margin: "0",
                          fontSize: "16px",
                          fontWeight: "bold",
                          textAlign: "left",
                        }}
                      >
                        India
                      </h5>
                    </div>
                    <ul style={{ paddingLeft: "0", listStyle: "none", margin: "0" }}>
                      <li
                        style={{
                          marginBottom: "8px",
                          display: "flex",
                          alignItems: "flex-start",
                        }}
                      >
                        <i
                          className="fa fa-map-marker"
                          style={{
                            color: "#ffd700",
                            marginRight: "10px",
                            marginTop: "3px",
                            minWidth: "15px",
                          }}
                        />
                        <p
                          style={{
                            color: "#fff",
                            margin: "0",
                            textAlign: "left",
                            fontSize: "12px",
                            lineHeight: "1.4",
                          }}
                        >
                          {indiaContact.address}
                        </p>
                      </li>
                      <li
                        style={{
                          marginBottom: "4px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <i
                          className="fa fa-phone"
                          style={{
                            color: "#ffd700",
                            marginRight: "10px",
                            minWidth: "15px",
                          }}
                        />
                        <Link
                          to={`tel:${indiaContact.mobile}`}
                          style={{
                            color: "#fff",
                            textDecoration: "none",
                            fontSize: "12px",
                          }}
                        >
                          {indiaContact.mobile}
                        </Link>
                      </li>
                      <li
                        style={{
                          marginBottom: "4px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <i
                          className="fa fa-envelope"
                          style={{
                            color: "#ffd700",
                            marginRight: "10px",
                            minWidth: "15px",
                          }}
                        />
                        <Link
                          to={`mailto:${indiaContact.email}`}
                          style={{
                            color: "#fff",
                            textDecoration: "none",
                            fontSize: "12px",
                          }}
                        >
                          {indiaContact.email}
                        </Link>
                      </li>
                    </ul>
                  </div>

                  {/* Sri Lanka Contact */}
                  <div className="contact-section" style={{ marginBottom: "25px" }}>
                    <div
                      style={{
                        backgroundColor: "#1a365d",
                        padding: "8px 12px",
                        marginBottom: "10px",
                        borderLeft: "4px solid #ffd700",
                      }}
                    >
                      <h5
                        style={{
                          color: "#ffd700",
                          margin: "0",
                          fontSize: "16px",
                          fontWeight: "bold",
                          textAlign: "left",
                        }}
                      >
                        Sri Lanka
                      </h5>
                    </div>
                    <ul style={{ paddingLeft: "0", listStyle: "none", margin: "0" }}>
                      <li
                        style={{
                          marginBottom: "4px",
                          display: "flex",
                          alignItems: "flex-start",
                        }}
                      >
                        <i
                          className="fa fa-map-marker"
                          style={{
                            color: "#ffd700",
                            marginRight: "10px",
                            marginTop: "3px",
                            minWidth: "15px",
                          }}
                        />
                        <p
                          style={{
                            color: "#fff",
                            margin: "0",
                            textAlign: "left",
                            fontSize: "12px",
                            lineHeight: "1.4",
                          }}
                        >
                          {sriLankaContact.address}
                        </p>
                      </li>
                      <li
                        style={{
                          marginBottom: "2px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <i
                          className="fa fa-phone"
                          style={{
                            color: "#ffd700",
                            marginRight: "10px",
                            minWidth: "15px",
                          }}
                        />
                        <Link
                          to={`tel:${sriLankaContact.mobile}`}
                          style={{
                            color: "#fff",
                            textDecoration: "none",
                            fontSize: "12px",
                          }}
                        >
                          {sriLankaContact.mobile}
                        </Link>
                      </li>
                      <li
                        style={{
                          marginBottom: "2px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <i
                          className="fa fa-envelope"
                          style={{
                            color: "#ffd700",
                            marginRight: "10px",
                            minWidth: "15px",
                          }}
                        />
                        <Link
                          to={`mailto:${sriLankaContact.email}`}
                          style={{
                            color: "#fff",
                            textDecoration: "none",
                            fontSize: "12px",
                          }}
                        >
                          {sriLankaContact.email}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>


              {/* Location Section */}
              <div className="col-12 col-md-6 col-lg-3">
                <div className="foot-contact">
                  <div className="section-heading">
                    <h2 className="entry-title">Location</h2>
                  </div>



                  {/* India Location */}
                  <div
                    style={{
                      backgroundColor: "#1a365d",
                      padding: "8px 12px",
                      marginBottom: "10px",
                      borderLeft: "4px solid #ffd700",
                    }}
                  >
                    <h5
                      style={{
                        color: "#ffd700",
                        margin: "0",
                        fontSize: "16px",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      India
                    </h5>
                  </div>
                  <div>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.3756894524786!2d78.0276628153485!3d9.954949399485647!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b00c9cdb5bdb63b%3A0x15e8054b499897af!2sLasalle%20Boys%20Town!5e0!3m2!1sen!2sus!4v1696838500000!5m2!1sen!2sus"
                      width="300"
                      height="150"
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Lasalle Boys Town - India"
                      style={{ border: "none" }}
                    />
                  </div>
                  {/* Sri Lanka Location */}
                  <div
                    style={{
                      backgroundColor: "#1a365d",
                      padding: "8px 12px",
                      marginBottom: "10px",
                      borderLeft: "4px solid #ffd700",
                    }}
                  >
                    <h5
                      style={{
                        color: "#ffd700",
                        margin: "0",
                        fontSize: "16px",
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      Sri Lanka
                    </h5>
                  </div>
                  <div style={{ marginBottom: "20px" }}>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1530.5348146365025!2d79.8603539!3d6.9624038!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae25892b0c5f21d%3A0x64d65607eabaa544!2sDe%20La%20Salle%20College%2C%20Colombo!5e0!3m2!1sen!2sus!4v1697020000000!5m2!1sen!2sus"
                      width="300"
                      height="150"
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="De La Salle Provincialate Secretariat - Sri Lanka"
                      style={{ border: "none" }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div style={{ marginBottom: "-17px" }}>
              <p
                className="text-center"
                style={{ fontSize: "14px", color: "white" }}>
                Copyright © {currentYear} De La Salle Brothers, All rights
                reserved. Powered by{" "}
                <a
                  className="tech"
                  style={{
                    color: "#ffd700",
                    textDecoration: "none !important",
                  }}
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.boscosofttech.com/">
                  Boscosofttech
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;




// import { Link } from "react-router-dom";
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { ApiUrl } from "./API/Api";

// function Footer() {
//   const [contactInfo, setContactInfo] = useState({
//     mobile: "",
//     email: "",
//     address: "",
//     googleMapsUrl: "",
//   });

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(`${ApiUrl}/get/contactDetails`);
//         setContactInfo(response?.data?.data);
//       } catch (error) {
//         console.error("Error fetching contact information:", error);
//       }
//     };

//     fetchData();
//   }, []);
//   const currentYear = new Date().getFullYear();

//   return (
//     <>
//       <footer className="site-footer">
//         <div className="footer-widgets">
//           <div className="container">
//             <div className="row">
//               <div className="col-12 col-md-6 col-lg-3">
//                 <div className="section-heading">
//                   <h2 className="entry-title">About Us</h2>
//                 </div>
//                 <div className="row" style={{ marginTop: "-19px" }}>
//                   <div className="col-4">
//                     <img
//                       src="/images/all-img/delasalle.png"
//                       alt=""
//                       style={{
//                         display: "block",
//                         marginLeft: "-50px"
//                       }}
//                     />
//                   </div>
//                   <div className="col-8">
//                     <p
//                       style={{
//                         color: "white",
//                         textAlign: "justify ",
//                         fontSize: "13px",
//                       }}>
//                       Founder of the Institute of the brothers of the Christian Schools (De Lasalle Brothers), Patron of Christian teachers, Educational Reformer and Father of Modern Pedagogy.
//                     </p>
//                   </div>
//                   <p
//                     style={{
//                       color: "white",
//                       textAlign: "justify",
//                       fontSize: "13px",
//                     }}>
//                     The Brothers of the Christian Schools, also known as De La Salle Brothers, is a religious congregation of men founded by Saint John Baptist De La Salle, patron saint of teachers of youth.
//                   </p>
//                 </div>
//               </div>

//               <div className="col-12 col-md-6 col-lg-3">
//                 <div className="foot-latest-news">
//                   <div className="section-heading">
//                     <h2 className="entry-title">Lasallian World
//                     </h2>
//                   </div>
//                   <a href="https://www.google.com/maps/d/u/0/viewer?ll=-3.81666561775622e-14%2C123.14054315101906&z=1&mid=1kiTIBWP9BQikhL7NlrCTwnVN5Ax9gz-O" target="_blank" rel="noopener noreferrer">
//                     <img src="/images/all-img/footimage.jpg" alt="nodata" className="img-fluid" style={{ marginTop: "-20px" }} />
//                   </a>
//                 </div>
//               </div>

//               <div className="col-12 col-md-6 col-lg-3">
//                 <div className="foot-contact">
//                   <div className="section-heading">
//                     <h2 className="entry-title">Contact Us</h2>
//                   </div>
//                   <div className="contact-us">
//                     <ul>
//                       <li>
//                         <i className="fa fa-map-marker mr-2" />
//                         <span>
//                           <p
//                             style={{
//                               color: "#fff",
//                               marginLeft: "16px",
//                               textAlign: "left",
//                             }}>
//                             {contactInfo?.address}
//                           </p>
//                         </span>
//                       </li>
//                       <li>
//                         <i className="fa fa-phone mr-2" />
//                         <Link to={`tel:${contactInfo?.mobile}`}>
//                           {contactInfo?.mobile}
//                         </Link>
//                       </li>
//                       <li>
//                         <i className="fa fa-envelope mr-2" />
//                         <Link to={`mailto:${contactInfo?.email}`}>
//                           {contactInfo?.email}
//                         </Link>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-12 col-md-6 col-lg-3">
//                 <div className="foot-contact">
//                   <div className="section-heading">
//                     <h2 className="entry-title">Location</h2>
//                   </div>
//                   <iframe
//                     src={contactInfo.googleMapsUrl}
//                     width="300"
//                     height="200"
//                     allowFullScreen=""
//                     loading="lazy"
//                     referrerPolicy="no-referrer-when-downgrade"
//                     title="salem"
//                     style={{ marginTop: "-30px" }}
//                   />
//                 </div>
//               </div>
//             </div>
//             <div style={{ marginBottom: "-17px" }}>
//               <p
//                 className="text-center"
//                 style={{ fontSize: "14px", color: "white" }}>
//                 Copyright © {currentYear} De La Salle Brothers, All rights
//                 reserved. Powered by
//                 <a
//                   className="tech"
//                   style={{ color: "#ffd700", textDecoration: "none !important" }}
//                   target="_blank"
//                   rel="noreferrer"
//                   href="https://www.boscosofttech.com/">
//                   &nbsp;Boscosofttech
//                 </a>
//               </p>
//             </div>
//           </div>
//         </div>
//       </footer>
//     </>
//   );
// }

// export default Footer;
